import ListPageWrapper from "../../../ListPageWrapper";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {SortOrder} from "ts-protocol-extension";
import {searchIndex, SearchIndex} from "../../../../io/HttpClient";
import ListOption from "../../../ListOption";
import ListOrder from "../../../ListOrder";
import {
    AssetSolarWithdrawalOptionValueObject
} from "../../../../data/value-object/asset/AssetSolarWithdrawalOptionValueObject";
import {
    AssetSolarWithdrawalOptionSearchOption
} from "../../../../data/search-option/asset/AssetSolarWithdrawalOptionSearchOption";
import {AssetSolarWithdrawalOptionIO} from "../../../../io/AssetIO";
import {
    AssetSolarWithdrawalOptionDescription
} from "../../../../data/description/asset/AssetSolarWithdrawalOptionDescription";
import {AssetSolarWithdrawalOptionDescriptor} from "../../../../data/descriptor/asset/AssetSolarWithdrawalOptionDescriptor";
import {
    AssetSolarWithdrawalOptionSearchOptionDescription
} from "../../../../data/description/asset/AssetSolarWithdrawalOptionSearchOptionDescription";
import {
    applyAssetSolarWithdrawalOptionSearchOption,
    AssetSolarWithdrawalOptionSearchOptionField
} from "../../../search-option-field/asset/AssetSolarWithdrawalOptionSearchOptionField";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<AssetSolarWithdrawalOptionValueObject[]>([])
    const option = useStatePair<AssetSolarWithdrawalOptionSearchOption>({})
    const index = useStatePair<SearchIndex>(searchIndex())

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={AssetSolarWithdrawalOptionIO}
                items={items}
                option={option.value}
                index={index}
                description={AssetSolarWithdrawalOptionDescription}
                descriptor={AssetSolarWithdrawalOptionDescriptor}
                showPost
                onPostClick={() => document.location = '/assets/solars/withdrawalOptions/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/assets/solars/withdrawalOptions/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={AssetSolarWithdrawalOptionSearchOptionDescription}
                fields={AssetSolarWithdrawalOptionSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyAssetSolarWithdrawalOptionSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={AssetSolarWithdrawalOptionDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}